// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ConnectionStatusMessage, ConnectionStatusMessageT, verifyConnectionStatusMessage } from './connection-status-message';
import { DoorStatusMessage, DoorStatusMessageT, verifyDoorStatusMessage } from './door-status-message';
import { EarthquakeProtectionMessage, EarthquakeProtectionMessageT, verifyEarthquakeProtectionMessage } from './earthquake-protection-message';
import { EarthquakeStatusMessage, EarthquakeStatusMessageT, verifyEarthquakeStatusMessage } from './earthquake-status-message';
import { ElevatorStatusContent, unionToElevatorStatusContent, unionListToElevatorStatusContent } from './elevator-status-content';
import { GeneralStatusMessage, GeneralStatusMessageT, verifyGeneralStatusMessage } from './general-status-message';
import { LoadWeigherStatusMessage, LoadWeigherStatusMessageT, verifyLoadWeigherStatusMessage } from './load-weigher-status-message';
import { ModeStatusMessage, ModeStatusMessageT, verifyModeStatusMessage } from './mode-status-message';
import { TrafficStatusMessage, TrafficStatusMessageT, verifyTrafficStatusMessage } from './traffic-status-message';


export class ElevatorStatusMessage implements flatbuffers.IUnpackableObject<ElevatorStatusMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ElevatorStatusMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsElevatorStatusMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorStatusMessage):ElevatorStatusMessage {
  return (obj || new ElevatorStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsElevatorStatusMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorStatusMessage):ElevatorStatusMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ElevatorStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

statusType():ElevatorStatusContent {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : ElevatorStatusContent.NONE;
}

status<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startElevatorStatusMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addStatusType(builder:flatbuffers.Builder, statusType:ElevatorStatusContent) {
  builder.addFieldInt8(0, statusType, ElevatorStatusContent.NONE);
}

static addStatus(builder:flatbuffers.Builder, statusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, statusOffset, 0);
}

static endElevatorStatusMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // status
  return offset;
}

static createElevatorStatusMessage(builder:flatbuffers.Builder, statusType:ElevatorStatusContent, statusOffset:flatbuffers.Offset):flatbuffers.Offset {
  ElevatorStatusMessage.startElevatorStatusMessage(builder);
  ElevatorStatusMessage.addStatusType(builder, statusType);
  ElevatorStatusMessage.addStatus(builder, statusOffset);
  return ElevatorStatusMessage.endElevatorStatusMessage(builder);
}

unpack(): ElevatorStatusMessageT {
  return new ElevatorStatusMessageT(
    this.statusType(),
    (() => {
      const temp = unionToElevatorStatusContent(this.statusType(), this.status.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: ElevatorStatusMessageT): void {
  _o.statusType = this.statusType();
  _o.status = (() => {
      const temp = unionToElevatorStatusContent(this.statusType(), this.status.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}



unpackFields(...fields: string[]): ElevatorStatusMessageT {
  const t = new ElevatorStatusMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('status_type')) {
    t.statusType = this.statusType();
  }
  if (fieldSet.has('status')) {
    t.status = (() => {
      const temp = unionToElevatorStatusContent(this.statusType(), this.status.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
  }
  return t;
}
}

export class ElevatorStatusMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public statusType: ElevatorStatusContent = ElevatorStatusContent.NONE,
  public status: ConnectionStatusMessageT|DoorStatusMessageT|EarthquakeProtectionMessageT|EarthquakeStatusMessageT|GeneralStatusMessageT|LoadWeigherStatusMessageT|ModeStatusMessageT|TrafficStatusMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  if (this.status === null || this.status === undefined) {
    throw new Error('Required field "status" is not set');
  }
  const status = builder.createObjectOffset(this.status);

  return ElevatorStatusMessage.createElevatorStatusMessage(builder,
    this.statusType,
    status
  );
}

clone(): ElevatorStatusMessageT {
  const obj = new ElevatorStatusMessageT();
  obj.statusType = this.statusType;
  obj.status = this.status !== null && typeof (this.status as any).clone === 'function' ? (this.status as any).clone() : this.status;
  return obj;
}

equals(other: ElevatorStatusMessageT): boolean {
  if (this.statusType !== other.statusType) return false;
  if (this.status !== null && other.status !== null) {
    if (typeof (this.status as any).equals === 'function') {
      if (!(this.status as any).equals(other.status)) return false;
    } else if (this.status !== other.status) return false;
  } else if (this.status !== other.status) return false;
  return true;
}
}

export function verifyElevatorStatusMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, 'status');
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // EarthquakeProtectionMessage
            { const o = verifier.readInt32(pos); verifyEarthquakeProtectionMessage(verifier, pos + o); }
            break;
          case 2: // EarthquakeStatusMessage
            { const o = verifier.readInt32(pos); verifyEarthquakeStatusMessage(verifier, pos + o); }
            break;
          case 3: // GeneralStatusMessage
            { const o = verifier.readInt32(pos); verifyGeneralStatusMessage(verifier, pos + o); }
            break;
          case 4: // ConnectionStatusMessage
            { const o = verifier.readInt32(pos); verifyConnectionStatusMessage(verifier, pos + o); }
            break;
          case 5: // ModeStatusMessage
            { const o = verifier.readInt32(pos); verifyModeStatusMessage(verifier, pos + o); }
            break;
          case 6: // DoorStatusMessage
            { const o = verifier.readInt32(pos); verifyDoorStatusMessage(verifier, pos + o); }
            break;
          case 7: // TrafficStatusMessage
            { const o = verifier.readInt32(pos); verifyTrafficStatusMessage(verifier, pos + o); }
            break;
          case 8: // LoadWeigherStatusMessage
            { const o = verifier.readInt32(pos); verifyLoadWeigherStatusMessage(verifier, pos + o); }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, 'status');
  } finally {
    verifier.popDepth();
  }
}
